"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Template3SliderGeneric = void 0;

var react_1 = __importDefault(require("react"));

var react_slick_1 = __importDefault(require("react-slick"));

var component_library_waas_templates_template_3_slider_icons_1 = require("@tradesorg-components/component-library-waas-templates.template-3-slider-icons");

var component_library_waas_templates_template_3_slider_icons_2 = require("@tradesorg-components/component-library-waas-templates.template-3-slider-icons");

function Template3SliderGeneric(_a) {
  var title = _a.title,
      subTitle = _a.subTitle,
      categories = _a.categories,
      _a$componentsToRender = _a.componentsToRender,
      componentsToRender = _a$componentsToRender === void 0 ? [] : _a$componentsToRender,
      customSetting = _a.customSetting,
      props = __rest(_a, ["title", "subTitle", "categories", "componentsToRender", "customSetting"]);

  var settings = customSetting || {
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    dots: false,
    dotClass: 'dotClass',
    infinite: componentsToRender.length > 6,
    prevArrow: react_1.default.createElement(component_library_waas_templates_template_3_slider_icons_1.ArrowLeftComponentVerticalPosition, null),
    nextArrow: react_1.default.createElement(component_library_waas_templates_template_3_slider_icons_2.ArrowRightComponentVerticalPosition, null),
    responsive: [{
      breakpoint: 1359,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0
      }
    }]
  };
  return react_1.default.createElement("div", Object.assign({
    className: "slider-wrapper"
  }, props), react_1.default.createElement(react_slick_1.default, Object.assign({}, settings), componentsToRender.length && componentsToRender));
}

exports.Template3SliderGeneric = Template3SliderGeneric;